
import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_baseURL
})

export default api;